"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainError = void 0;
const handled_error_1 = require("./handled.error");
class DomainError extends handled_error_1.HandledError {
    constructor(message, code) {
        super(message);
        this.message = message;
        this.code = code;
    }
}
exports.DomainError = DomainError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZG9tYWluLmVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2RvbWFpbi5lcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtREFBOEM7QUFFOUMsTUFBYSxXQUFZLFNBQVEsNEJBQVk7SUFDM0MsWUFDVyxPQUFlLEVBQ2YsSUFBYTtRQUV0QixLQUFLLENBQUMsT0FBTyxDQUFDLENBQUE7UUFITCxZQUFPLEdBQVAsT0FBTyxDQUFRO1FBQ2YsU0FBSSxHQUFKLElBQUksQ0FBUztJQUd4QixDQUFDO0NBQ0Y7QUFQRCxrQ0FPQyJ9